export enum AdminStateEnum {
  LOCKED = 'LOCKED',
  UNLOCKED = 'UNLOCKED'
}
